import React from 'react'
import {Flex, Heading, Image, Text, useColorMode} from "@chakra-ui/react";
import {getCloudinaryImagePath} from "./App";

const Problem = () => {

  const { colorMode } = useColorMode()
  const textColor = colorMode === 'light' ? 'black' : 'white'

  const renderImage = () => {
    return (
      <Image
        src = { getCloudinaryImagePath('resource-card_zc4jll.png') }
        w = { ['33vw', '36vw', '40vw', '50vw'] }
        ml = { [-2, -2, -2, 0] }
        mb = { [4, 4, 8, 0] }
        h = 'full'
        mr = { [0, 0, 0, 16, 24, 32] }
        fit = 'contain'
      />
    )
  }

  const renderText = () => {
    return (
      <Flex
        direction = 'column'
        align = 'flex-start'
        justify = 'center'
      >
        <Heading
          fontSize = { ['lg', 'xl', '2xl', '3xl'] }
          mb = { 4 }
          color = { textColor }
          h = { 'auto' }
        >
          {/*Reclaiming power from centralized banks and a movement against consolidation of wealth*/}
          Decentralizing credit and redistributing wealth
        </Heading>
        <Text
          fontSize = { ['sm', 'md', 'lg', 'xl'] }
          color = { textColor }
        >
          ReSource does not only remove intermediaries, but decentralizes the logic of credit itself: Creditworthy businesses borrow from each other at 0% interest, and pay their debts by lending at the same terms when they’re ready.
        </Text>
      </Flex>
    )
  }

  return (
    <Flex
      direction = { ['column', 'column', 'column', 'row'] }
      justify = 'space-between'
      align = { 'flex-start' }
      p = { [8, 8, 12, 16] }
      mx = { [8, 8, 12, 16] }
      my = { [16, 16, 24, 32] }
      bgColor = 'primaryBg'
      borderRadius = 'xl'
    >
      { renderImage() }
      { renderText() }
    </Flex>
  )
}

export default Problem;